import Icon, { IconNames } from './Icon';

export { IconNames };
export default Icon;
